import { render, staticRenderFns } from "./InputJGSelect.vue?vue&type=template&id=8ac64e52&"
import script from "./InputJGSelect.vue?vue&type=script&lang=js&"
export * from "./InputJGSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports